"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDebtDate = void 0;
var setDebtDate = function (date) {
    return new Date(new Date(date).setHours(2));
};
exports.setDebtDate = setDebtDate;
